const replyTime = (reply) => Date.parse(reply.messageSendDate ?? reply.messageDate);

// Respuestas de un mensaje del Libro de la más antigua a la más reciente por fecha de envío
// (o de creación si no tiene fecha de envío). Las que no tienen ninguna fecha válida quedan al
// final, en su orden original. Devuelve un arreglo nuevo; nulo o undefined -> [].
export const sortRepliesBySendDate = (replies) => {
    const dated = (replies ?? []).filter((reply) => !Number.isNaN(replyTime(reply)));
    const undated = (replies ?? []).filter((reply) => Number.isNaN(replyTime(reply)));
    return [...dated.sort((a, b) => replyTime(a) - replyTime(b)), ...undated];
};
